__turbopack_context__.v({
  "paddingBottom": "section-module-scss-module__9wXI9q__paddingBottom",
  "paddingTop": "section-module-scss-module__9wXI9q__paddingTop",
  "section": "section-module-scss-module__9wXI9q__section",
});
